import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-white" data-id="element-113" data-mp="1o3x1pk7r0m0y">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-114" data-mp="1o5zvmfc0uzay">
        <div className="rounded-3xl bg-sage-tint border border-sage-soft p-8 sm:p-12 text-center" data-id="element-115" data-mp="222n2paxov5ul">
          <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white border border-sage-soft" data-id="element-116" data-mp="1x54pv9gjw6hb">
            <ShieldCheckIcon className="w-8 h-8 text-sage" aria-hidden="true" data-id="element-117" data-mp="19cek5hz8qjfh" />
          </span>
          <h2 id="guarantee-heading" className="mt-6 font-serif font-bold text-ink text-xl sm:text-3xl leading-snug" data-id="element-118" data-mp="14dtg17gvbflr">
            7-Day Guarantee — No Questions Asked
          </h2>
          <p className="mt-4 text-ink-soft text-base leading-relaxed max-w-xl mx-auto" data-id="element-119" data-mp="qnzscsh3n1dm">
            Open the tomes. Use them in your real sessions. If in 7 days it&apos;s
            not what you expected, we refund 100% — no forms, no hassle.
          </p>
          <p className="mt-5 inline-block rounded-full bg-white border border-sage-soft px-4 py-2 text-sm font-semibold text-sage" data-id="element-120" data-mp="oz9kqu71izie">
            Refund rate: under 1%.
          </p>
        </div>
      </div>
    </section>;
}